


let menuBurger = $('#menu-burger'),
    burger = $('#burger'),
    menuAccount = $('#menu-account'),
    account = $('#account');


// Отображение бургер меню
burger.on("click", function () {
    if (menuAccount.hasClass("show")) return smoothCloseMenu(menuAccount)
    showOneMenu(menuBurger)
    menuAccount.toggleClass("show")
    $(document.body).addClass("overflow")
    setTimeout(() => {
        menuAccount.toggleClass("collapsed")
        menuAccount.toggleClass("collapse")
    })
})

// Отображение меню аккаунта
account.on("click", function () {
    if (menuBurger.hasClass("show")) return smoothCloseMenu(menuBurger)
    showOneMenu(menuAccount)
    menuBurger.toggleClass("show")
    $(document.body).addClass("overflow")
    setTimeout(() => {
        menuBurger.removeClass("collapsed")
        menuBurger.toggleClass("collapse")
    })
})

let btnToTop = $('#btn-to-top')

// Показать кнопку скрола наверх страницы
$(window).on("scroll", function () {
    ($(this).scrollTop() > 300)
        ? btnToTop.addClass("show")
        : btnToTop.removeClass("show")
})


// Вернуться наверх страницы
btnToTop.on("click", function () {
    $(this).removeClass("show")
    window.scroll(0, 0)
})

// Инициализация slinky menu (ПОДСКАЗКА: для отслеживания страницы меню используется метод jump)
let slinkyMenu = $('.slinky-menu-mobile').slinky({
    title: true
})

let layoutFeedback = $('#layout-feedback')

// Открытие формы обратной связи
$('#feedback').on("click", function (event) {
    event.preventDefault()
    layoutFeedback.addClass("show")
    setTimeout(() => {
        layoutFeedback.addClass('collapse')
    })
})

// Закрытие формы обратной связи
$('#close-feedback, #btn-cancel-form').on("click",  function (event) {
    event.preventDefault()
    hideFeedBackForm()
})
// Закрытие формы обратной связи при клике вне неё
$(document).on("click", function (event) {
    if (event.target === layoutFeedback[0]) hideFeedBackForm()
})

// Выделение элемента в slinky menu при определенной странице

console.log(window.location.pathname.split("/")[1])
let defaultPathForSlinky = window.location.pathname.split("/")[1] + "/" + window.location.pathname.split("/")[2]
$(".menu-burger-item").each((index , elem) => {
    if (elem.pathname === $(location)[0].pathname && $(location)[0].pathname.includes(defaultPathForSlinky)) {
        $(elem).addClass("active-page")
        $(elem).closest(".menu-burger-item.next").addClass("active-page")
        slinkyMenu.jump($(elem).parent().parent()[0])
    }
    else if ($(location)[0].pathname.includes(`/${$(elem).parent().parent().attr("data-title")}`)) {
        slinkyMenu.jump($(elem).parent().parent()[0])
    }
})

// Выделение элемента в submenu при определенной странице
$(".dropdown-body-item-submenu").each((index, elem) => {
    if (elem.pathname === $(location)[0].pathname) {
        $(elem).addClass("active")
        $(elem).closest(".dropdown-item").addClass("active")
    }
    else if ($(location)[0].pathname.includes(`/${$(elem).parent().parent().attr("data-title")}`)) {
        $(elem).closest(".dropdown-item").addClass("active")
    }
})

// Отобразить фильтры на мобильной версии
$("#btn-filter").on("click", function () {
    $(document.body).css({overflow: "hidden"})
    $("#filter").addClass("active")
})

// Скрыть фильтр на мобильной версии
$("#close-filter").on("click", function (event) {
    closeFilter($(this)[0], event)
})

// Делаем активными фильтры типа tag
$(".filter-tag").on("click", function () {
    ($(this).hasClass("active"))
        ? $(this).removeClass("active")
        : $(this).addClass("active")
})

// Сброс всех фильтров
$("#reset-all-filters").on("click", function () {
    $(".filter-tag").removeClass("active")
    $(".filter-radio-input > input").each((ind, elem) => {
        elem.checked = false
    })
})

// Сброс отдельных фильтров
$(".reset-filter").on("click", function () {
    $(this).prev().children().each((index, wrapInput) => {
        ($(wrapInput).hasClass("filter-tag"))
            ? $(wrapInput).removeClass('active')
            : $(wrapInput).children("input").each((index, input) => { $(input)[0].checked = false })
    })
})

// логика работы скрытых блоков
$('#btn-view-presentation').on("click", function () {
    $(".hidden-block").removeClass("active")
    $(this).addClass("hide")
    const wrapPresent = $("#wrap-presentation")
    wrapPresent.addClass("active")
    wrapPresent.find(".presentation-product").css({height: "auto"})
})

// логика работы лайков
$('.btn-rate-review[data-likeReview="true"]').on("click", function () {
    $(this).toggleClass("active")
    if ($(this).next().hasClass("active")) {
        $(this).addClass("active")
        $(this).next().removeClass("active")
    }
})

// логика работы дизлайков
$('.btn-rate-review[data-dislikeReview="true"]').on("click", function () {
    $(this).toggleClass("active")
    if ($(this).prev().hasClass("active")) {
        $(this).addClass("active")
        $(this).prev().removeClass("active")
    }
})

// Просмотр комментариев к отзыву
$('.comments-review[data-viewComment="true"]').on("click", function () {
    $(this).closest(".wrapper-manage-review").find(".wrapper-comment").toggleClass("active")
})

// Запоминаем имя пользователя
const usernamePublishDefault = $('#username-publish').text()

// Смена видимости имени при подаче вопрос о товаре, заказе
$("#switch-username").on("change", function () {
    ($(this).attr("checked"))
        ? $("#username-publish").text("Анонимный пользователь")
        : $("#username-publish").text(usernamePublishDefault)
})

$(".switched-input").on("click", function () {
    if (!$(this).attr("checked")) {
        $(this).attr("checked", "checked")
        $(this).next().addClass("active")
        $(this).parent().find(".switched::before").addClass("active")
    }

    else {
        $(this).next().removeClass("active")
        $(this).parent().find(".switched::before").removeClass("active")
        $(this).removeAttr("checked", "checked")
    }
})

// логика кнопки для показа больше ответов по товару
let prevTextAnswer
$('.more-answer[data-view-answer="true"]').on("click", function () {
    let title = $(this).children("div");
    if (!prevTextAnswer) prevTextAnswer = title.text();
    (title.text() !== "Скрыть")
        ? title.text("Скрыть")
        : title.text(prevTextAnswer)
    $(this).next().toggleClass("active")
})

// Раскрытие блока описания заказа, отклика
$(".read-continue").on("click", function () {
    ($(this).text() === "Читать далее") ? $(this).text("Скрыть") : $(this).text("Читать далее")
    $(this).toggleClass('active')

    $(this).parent().find(".inner-info-executor").toggleClass("active")
    $(this).parent().find(".description-content").toggleClass("open")
    $(this).parent().find(".hiding-block").toggleClass("hide")

})

// Реализация прокрутки имени файла
$(".file").on("mouseover", function () {
    $(this).find(".filename").scrollTop($(this).find(".filename")[0].scrollHeight)
})
$(".file").on("mouseout", function () {
    $(this).find(".filename").scrollTop(0)
})

let overlay = $(".overlay")[0]

// Открытие модалки закрытия заказа, отклика
$("#close-order").on("click", function () {
    openModal($(".modal-close-order"))
})

// Открытие модалки редактирования заказа, отклика
$("#edit-order").on("click", function () {
    openModal($(".modal-edit-order"))
})

// Закрытие конкретного модального окна по кнопке
$(".undo-action").on("click", function (event) {
    event.preventDefault()
    closeModal($(this).closest(".modal"))
})

// Закрытие модального окна по нажатию на крестик
$(".cross-modal").on("click", function () {
    closeModal($(this).closest(".modal"))
})

let translateSlider = 0 // размер перемещения слайдера
let childElems = $(".slider-body").children().length // количество карточек залов

// Прокрутка слайдера с залами вправо
$(".slider-arrow-right").on("click", function () {
    // console.log(childElems)
    if (translateSlider < (childElems - 3) * 230) {
        translateSlider += 230
        $(".slider-body").css({ transform: `translate(-${translateSlider}px)` })
    }
})

// Прокрутка слайдера с залами влево
$(".slider-arrow-left").on("click", function () {
    if (translateSlider !== 0) {
        translateSlider -= 230
        $(".slider-body").css({ transform: `translate(-${translateSlider}px)` })
    }
})

$(".btn-hint").on("click", function () {
    $(this).text(changeContentBtnHint($(this).text()))
    $(".hint-profile-fullness").toggleClass("active")
})




// Модалка с переносом встреч, TODO переписать на JQuery
let transferMeetingModal = document.querySelector(".modal-transfer-meeting")
if (transferMeetingModal) {
    let returnToRooms = document.querySelector(".return-rooms")
    let returnToTables = document.querySelector(".return-tables")
    let choiceTableModal = document.querySelector(".modal-transfer-meeting-tables")
    let choiceTimeModal = document.querySelector(".modal-transfer-meeting-time")
    let btnEnterHalls = document.querySelectorAll(".btn-enter-hall")
    let enterHallName;

    // Выбор помещения и переход на модальное окно со столами
    btnEnterHalls.forEach((elem) => {
        elem.addEventListener("click", () => {
            enterHallName = elem.parentNode.children[2].children[0].innerText
            closeModal(transferMeetingModal)
            openModal(choiceTableModal)
        })
    })
    // Возврат на модальное окно выбора помещения
    returnToRooms.addEventListener("click", () => {
        closeModal(choiceTableModal)
        openModal(transferMeetingModal)
    })

    let btnTables = document.querySelectorAll(".btn-table")

    btnTables.forEach((elem) => {
        elem.addEventListener("click", () => {
            closeModal(choiceTableModal)
            openModal(choiceTimeModal)
        })
    })

    //Возврат на модальное окно выбора стола
    returnToTables.addEventListener("click", () => {
        closeModal(choiceTimeModal)
        openModal(choiceTableModal)
    })

    if (choiceTimeModal) {
        //реализация выбора времени встречи
        const step = 5 // "шаг" 5 минут
        const intervalLength = 288
        //убираем 10 утренних часов (0:00 - 10:00) для того чтобы интервал смотрелся красивее
        const intervalMorning = 120
        //убираем 2 ночных часа (22:00 - 0:00)
        const intervalNight = 24

        const beautifyTime = (time) => {
            if (time.toString().length === 1) return "0" + time
            return time
        }

        const timeToSteps = (time) => {
            let [hours, minutes] = time.split(":")
            if (hours === 0) hours = 24
            return (hours * 60 / step) + Math.round(minutes / step)
        }

        const stepsToTime = (steps) => {
            const hours = Math.floor(steps / 12)
            const minutes = (steps - hours * 12) * 5
            return `${beautifyTime(hours)}:${beautifyTime(minutes)}`
        }

        const stepsToOffset = (steps) => {
            return (steps-intervalMorning)/(intervalLength-intervalMorning-intervalNight)*100 + "%"
        }

        const stepsToWidth = (steps) => {
            return (steps)/(intervalLength-intervalMorning-intervalNight)*100 + "%"
        }

        const interval = document.querySelector("#transferMeetinInterval")
        const intervalTooltip = interval.querySelector(".interval-tooltip")
        const intervalTooltipTime = interval.querySelector(".interval-tooltip-text").querySelector("span")

        const timeSlots = {
            available: [
                {
                    start: timeToSteps("12:00"),
                    end: timeToSteps("19:00")
                },
            ],
            appointment: [
                {
                    start: timeToSteps("12:00"),
                    end: timeToSteps("14:30")
                },
                {
                    start: timeToSteps("16:00"),
                    end: timeToSteps("17:45")
                }
            ]
        }

        // устанавливаем точки начала/конца интервалов
        const placeIntervalTips = () => {
            const intervalTips = interval.querySelectorAll(".interval-tip")

            intervalTips.forEach(el => el.remove())

            const timeSlotsFlattened = []

            Object.keys(timeSlots).forEach((key) => {
                const flattenedPoint = []
                timeSlots[key].forEach((point) => {
                    flattenedPoint.push(...Object.values(point))
                })
                timeSlotsFlattened.push(...flattenedPoint)
            })

            const tipPositions = [...new Set(timeSlotsFlattened)].sort((a, b) => a - b)

            tipPositions.forEach((tip, i) => {
                const tipEl = document.createElement("div")
                tipEl.classList.add("interval-tip")

                if (tipPositions[i+1] && (tipPositions[i+1] - tip < 7)) tipEl.classList.add("tip-time-top")

                tipEl.style.left = stepsToOffset(tip)
                tipEl.dataset.content = stepsToTime(tip)
                interval.appendChild(tipEl)
            })
        }

        const placeStripe = (start, end, classList) => {
            const stripeEl = document.createElement("div")
            stripeEl.classList.add(...classList)

            stripeEl.style.left = stepsToOffset(start)
            stripeEl.style.width = stepsToWidth(end - start)

            interval.appendChild(stripeEl)
        }

        const placeGreenStripe = () => {
            placeStripe(timeSlots.available[0].start, timeSlots.available[0].end, ["interval-stripe", "interval-stripe-green"])
        }

        const placeYellowStripes = () => {
            timeSlots.appointment.forEach(slot => {
                placeStripe(slot.start, slot.end, ["interval-stripe", "interval-stripe-yellow"])
            })
        }

        const placeIntervalStripes = () => {
            const intervalStripes = interval.querySelectorAll(".interval-stripe")

            intervalStripes.forEach(el => !el.classList.contains("interval-stripe-red") && el.remove())

            placeGreenStripe()
            placeYellowStripes()
        }

        const placeIntervalTooltip = (slot) => {
            const slotCenter = (slot.end + slot.start) / 2
            const intervalTooltipPos = `calc(${stepsToOffset(slotCenter)} - ${intervalTooltip.clientWidth / 2}px)`
            intervalTooltip.style.left = intervalTooltipPos
        }

        // инициализация
        let changingSlot = timeSlots.appointment[1]

        const renderInterval = () => {
            placeIntervalTips()
            placeIntervalStripes()
            placeIntervalTooltip(changingSlot)

            intervalTooltipTime.innerText = `${stepsToTime(changingSlot.start)} - ${stepsToTime(changingSlot.end)}`
        }

        const observer = new MutationObserver(() => {
            renderInterval()
        })

        observer.observe(choiceTimeModal, {
            attributes: true,
            attributeFilter: ["class"],
            childList: false
        })


        // редактирование интервала
        const intervalChangerInputs = document.querySelectorAll(".interval-changer-input")
        const [intervalStartInput, intervalEndInput] = intervalChangerInputs

        intervalChangerInputs.forEach(input => {
            let maskOptions = {
                mask: 'hh:mm',
                blocks: {
                    hh: {
                        mask: IMask.MaskedRange,
                        from: 12,
                        to: 18
                    },
                    mm: {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 59
                    }
                }
            };
            IMask(input, maskOptions);
        })

        const transferMeetButton = document.querySelector("#transferMeetButton")

        transferMeetButton.addEventListener("click", () => {
            if (!intervalStartInput.value || !intervalEndInput.value) return
            timeSlots.appointment[1].start = timeToSteps(intervalStartInput.value)
            timeSlots.appointment[1].end = timeToSteps(intervalEndInput.value)
            renderInterval()
        })
    }
}

$(".icon-clip").on('click', function () {
    copyLink($(this).closest(".section-about-product").attr("id"))
})


$('.cross-modal').on('click', function () {
    if ($(this).parent().parent().hasClass('modal-auth')){
        $(this).parent().parent().parent().removeClass('show')
    }
})

$('.wrapper-modal-auth').on('click', function (event) {
    if (event.target === $(this)[0]) {
        $(this).removeClass('show')
    }
})

let timeout

// При наведении на карточку товара активируем ее
$('.card-product, .card-service').on('mouseenter', function () {
    if (!$(this).attr("data-without-shadow")) {
        // timeout = setTimeout(() => {
        $(this).addClass('active')
        // }, 1500)
    }
})

// При уходе с карточки товара ставим первую фотографию
$('.card-product, .card-service').on('mouseleave', function () {
    // clearTimeout(timeout)
    $(this).removeClass('active')
    // $(this).find('.inner-photo-card-product-icon').attr('src', arrayPhoto[0])
    $('.slider-menu-photo-product.desktop div:first-child').addClass('active')
})

$(function () {
    $(".content-rating-ring").each((index, elem) => {
        const rating = $(elem).text().split('/')[0]
        if (rating === "0") {
            $(elem).closest(".rating-ring").addClass("null")
        }
        $(elem).closest(".rating-ring.green").css("background", `radial-gradient(closest-side, white 70%, transparent calc(70% + 1px) 100%), conic-gradient(var(--main-green) ${rating*10}%, var(--grey--100) 0)`)
        $(elem).closest(".rating-ring.dark-green").css("background", `radial-gradient(closest-side, white 70%, transparent calc(70% + 1px) 100%), conic-gradient(var(--secondary-dark-color) ${rating*10}%, var(--grey--100) 0)`)
    })
})

$(function () {
    let pathURL = window.location.pathname
    if (pathURL === "/ideas" || pathURL === "/add-idea") {
       $("#btn-add-idea").removeClass("active")
    }
})

function checkPassword(value) {
    if (value.length < 8)
        $("#require-pass-1").removeClass("success")
    else
        $("#require-pass-1").addClass("success")

    if (value.search(/[a-zа-яё]/) == -1)
        $("#require-pass-2").removeClass("success")
    else
        $("#require-pass-2").addClass("success")

    if (value.search(/[A-ZА-ЯЁ]/) == -1)
        $("#require-pass-3").removeClass("success")
    else
        $("#require-pass-3").addClass("success")

    if (value.search(/\d/) == -1)
        $("#require-pass-4").removeClass("success")
    else
        $("#require-pass-4").addClass("success")
    // console.log(!!(value.length > 8 && value.search(/[a-zа-яё]/) != -1 && value.search(/[A-ZА-ЯЁ]/) != -1 && value.search(/\d/) != -1))
    return !!(value.length > 8 && value.search(/[a-zа-яё]/) != -1 && value.search(/[A-ZА-ЯЁ]/) != -1 && value.search(/\d/) != -1);
}


let currentSlideRoom = 0
let clusterSlideRoom = 3
$("#slider-halls-arrow-right").on("click", function () {
    console.log($(this))
    if (currentSlideRoom >= $(this).parent().find(".card-hall-for-slider").length - 1 || clusterSlideRoom > $(this).parent().find(".card-hall-for-slider").length - 1) return
    currentSlideRoom++
    $(this).parent().find(".slide-halls-container").css("transform", `translateX(-${currentSlideRoom * 245}px)`)
    clusterSlideRoom++
})

$("#slider-halls-arrow-left").on("click", function () {
    if (currentSlideRoom <= 0) return
    currentSlideRoom--
    $(this).parent().find(".slide-halls-container").css("transform", `translateX(-${currentSlideRoom * 245}px)`)
    clusterSlideRoom--
})




function createMessage (text, chat_body) {
    if (!text)
        return


    let options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }
    let dateTime = new Date().toLocaleString("ru-RU", options).split(",")
    let message=
        `<div class="wrapper-message me-message">
             <div class="message">
                 <div class="meta-message">
                     <div class="title-meta-message">Вы ${dateTime[0]} в ${dateTime[1]}</div>
                 </div>
                 <div class="message-body">
                     <div class="message-content">${text}</div>
                     <div class="time-receiving">✓</div>
                 </div>
             </div>
        </div>`
    $(chat_body).append(message)
}


function transformUnixToDate (unixTime, format = false) {
    let tranformDateUNIX = new Date(unixTime * 1000)
    if (!format)
        return `${tranformDateUNIX.getFullYear()}.${(tranformDateUNIX.getMonth() + 1).toString().padStart(2, 0)}.${tranformDateUNIX.getDate()}`
    else
        return `${tranformDateUNIX.getDate()}.${(tranformDateUNIX.getMonth() + 1).toString().padStart(2, 0)}.${tranformDateUNIX.getFullYear()}`
}

function sendMessage (fm, body_chat) {
    if (fm === undefined) return;
    let FD = new FormData(fm)
    let $input = $(fm["message"])
    let $btn = $(fm["submit"])

    //в теле чата, считываем id сообщений
    let arr_messages = [];
    let item_messages = $(body_chat).children()
    if (item_messages != undefined && item_messages.length > 0) {
        for (const [key, value] of Object.entries(item_messages)) {
            if ($(value).data('message') != undefined) {
                arr_messages.push( $(value).data('message') );
            }
        }
    }
    let message_str = "";
    if (arr_messages.length > 0) {
        message_str = arr_messages.join()
    }
    FD.set('messages', message_str);
    $input.attr("disabled", "disabled")
    $btn.attr("disabled", "disabled")
    $.ajax({
        type: 'POST',
        url:  '/ajax',
        data: FD,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function ({response, description}) {
            if (response == true) {
                createMessage($input.val().replace(/\n/g, '<br>'), body_chat)
                $(body_chat).scrollTop($(".chat-body")[0].scrollHeight)
                $input.val("")
            }
            else {
                alerts("error", description)
            }
        },
        error: function (jqXHR, textStatus) {
            alerts("error", "Не удалось подключиться")
        },
        complete: function(jqXHR, textStatus) {
            $input.removeAttr("disabled")
            $btn.removeAttr("disabled")
        }
    })

    // Действия ниже должны выполнятся, только после успешного ajax запроса с ответом response == true

}


function getTimeByIdTimeClear(idTime, timeInterval) {
    if (Number(idTime) === 0)
        return "00:00"
    else {
        let hours = Math.floor(((Number(idTime)) * 5) / 60).toString().padStart(2, '0');
        let minutes = (((Number(idTime)) * 5) % 60).toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    }
}

// Функция для получения времени по id времени
function getTimeByIdTime(idTime) {
    if (Number(idTime) === 0)
        return "00:00"
    else {
        let hours = Math.floor(((Number(idTime) - 1) * 5) / 60).toString().padStart(2, '0');
        let minutes = (((Number(idTime) - 1) * 5) % 60).toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    }
}

function convertDateToIdTime (date) {
    let [hours, minutes] = date.split(":").map(elem => Number(elem))
    return ((hours * 60 + minutes) / 5)
}

// Переход на предыдущую страницу
function movePrevPage(baseLink) {
    let btnPrevPage = document.getElementById('btn-prev-page')
    if (!btnPrevPage) return;
    (document.referrer && document.referrer !== document.location.href && document.referrer.includes(document.location.origin))
        ? btnPrevPage.href = document.referrer.split(document.location.origin)[1]
        : btnPrevPage.href = baseLink
}

// Закрыть модальное окно
function closeModal(modal, event=null) {
    $(modal).removeClass("active")
    $(overlay).removeClass("active")
    $(document.body).removeClass('overflow')
}

// Открыть модальное окно
function openModal(modal = null) {
    if (!modal) return
    $(overlay).addClass("active")
    $(modal).addClass("active")
}

// Закрыть фильтр на мобилке
function closeFilter (elemForClose, event) {
    if (event.target === elemForClose) {
        filter.classList.remove('active')
        document.body.style.overflow = 'auto'
    }
}

// Установка кол-ва символов в инпуте с выводом в элемент
function setupCharacterCounter(input, label, maxLength) {
    const currentLength = $(input).val().length;
    if (currentLength === maxLength) {
        $(label).css({"color":"#eb0c0c"})
    } else {
        $(label).css({"color":"var(--grey-600)"})
    };
    $(label).text(`Введено символов: ${currentLength}/${maxLength}`);
}

// Копирование ссылки
function copyLink(idElem = null){
    let currentURL = document.location.origin.toString().concat(document.location.pathname)
    let url
    (idElem) ? url = currentURL + `#${idElem}` : url = currentURL

    navigator.clipboard.writeText(url).then(function () {
        Swal.fire({
            scrollbarPadding: false,
            icon: "success",
            title: "Ссылка скопирована"
        })
    }, function () {
        console.log('Ошибка копирования')
    });
}

// Скрыть форму обратной связи
function hideFeedBackForm (event) {
    if (event)
        event.preventDefault()
    layoutFeedback.removeClass("collapse")
    setTimeout(() => {
        layoutFeedback.removeClass("show")
    }, 200)
}

// Отображение одного меню
function showOneMenu (element) {
    if ($(element).hasClass('show')) {
        $(element).toggleClass('collapse')
        $(element).toggleClass('collapsed')
        $(element).toggleClass('show')
    }
}

// Плавное закрытие меню
function smoothCloseMenu(menu) {
    $(document.body).removeClass("overflow")
    setTimeout(() => {      // сначала меню плавно закрывается, а после элемент скрывается
        $(menu).toggleClass("show")
    },200)
    $(menu).toggleClass("collapse")
    $(menu).toggleClass("collapsed")
}

function changeContentBtnHint(content) {
    return (content === "Показать") ? "Скрыть" : "Показать"
}


/**
 * Парсер JSON
 * @param {string} str
 * @return {boolean}
 */
function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

/**
 * Авторегистрация event для обновления и подгрузки блока
 * @return {void}
 */
function registerUpdateBlocks() {
       let allBlocksUpdate = document.querySelectorAll('[data-block]');

       allBlocksUpdate.forEach((tag) => {
            if (tag.dataset.block != null && tag.dataset.target != null && tag.dataset.event != null && tag.dataset.type != null) {
                uploadBlock(tag.dataset.target,tag.dataset.block,tag.id,tag.dataset.event,tag.dataset.type);
            } else {
                let errorAlert = [];
                if (tag.dataset.target == null) {
                    errorAlert.push("data-target")
                }
                if (tag.dataset.event == null) {
                    errorAlert.push("data-event")
                }
                if (tag.dataset.type == null) {
                    errorAlert.push("data-type")
                }
                let phrase = errorAlert.join(', ');
                console.log("У блока с id="+tag.id+" заполнены не все атрибуты, требуются следующие атрибуты: "+phrase);
            }
       })

}

/**
 * Функция обновления блока
 * @param {string} idBlockTarget
 * @param {string} urlBlock
 * @param {string} idBlockListen
 * @param {string} typeEvent
 * @param {string} TypeUpdate
 */
async function uploadBlock(idBlockTarget,urlBlock,idBlockListen,typeEvent,TypeUpdate) {
        let BlockListen = document.getElementById(idBlockListen) // Кнопка сброса всех фильтров
        let BlockTarget = document.querySelector(idBlockTarget) // Кнопка сброса всех фильтров

        BlockListen.addEventListener(typeEvent, async () => {
            let data = await getDataBlock(urlBlock);
                if (data.response == true) {
                    if (TypeUpdate == "update") {
                        BlockTarget.innerHTML = data.data;
                    }
                    if (TypeUpdate == "add") {
                        BlockTarget.innerHTML += data.data;
                    }
                } else {
                    console.log("Ошибка загрузки блока причина: "+data.description);
                }

        })

}

/**
 * Получение данных по URL
 * @param {string} urlBlock
 * @return {object}
 */
async function getDataBlock (urlBlock) {
     return new Promise(function (resolve, reject) {
        let datablock = {};
        let urlBlocks = document.location.protocol+"//"+document.location.host+"/blocks"+urlBlock;
        var xhr = new XMLHttpRequest();
        xhr.open('get', urlBlocks, true);
        xhr.responseType = 'document';
        xhr.onload = function () {
            var status = xhr.status;
            if (status == 200) {

              if (IsJsonString(xhr.response.documentElement.innerHTML)) {
                      let desc = JSON.parse(xhr.response.documentElement.innerHTML);
                      datablock["response"] =  desc.response;
                      datablock["type"] = "json";
                      datablock["data"] = desc.data;
                      datablock["description"] = desc.description;
                      resolve(datablock);
              } else {
                      datablock["response"] = true;
                      datablock["type"] = "html";
                      datablock["data"] = xhr.response.documentElement.innerHTML;
                      datablock["description"] = "Ответ от "+document.location.protocol+"//"+document.location.host+urlBlock+" получен в виде html";
                      resolve(datablock);
              }


            } else if (status == 404) {
                 datablock["response"] = false;
                 datablock["type"] = "error";
                 datablock["data"] = null;
                 datablock["description"] = "Ошибка страница блока " + urlBlocks + " не существует, попробуй очистить кеш "+document.location.protocol + "//" + document.location.host +"/mcd/flush";
                 resolve(datablock);
            } else if (status == 500) {
                 datablock["response"] = false;
                 datablock["type"] = "error";
                 datablock["data"] = null;
                 datablock["description"] = "Ошибка страница блока " + urlBlocks + " не отвечает ";
                 resolve(datablock);
            } else {
                 reject(status);
            }

        };
        xhr.send();
    });


}

function setLocation(curLoc){
  try {
    history.pushState(null, null, curLoc);
    return;
  } catch(e) {}
  location.hash = '#' + curLoc;
}

function get_GET(name) {
    let url = new URL(window.location.href);
    return url.searchParams.get(name);
}

function add_GET(param, value) {
  let url = new URL(window.location.href);
  url.searchParams.append(param, value);
  setLocation(url);
}

function del_GET(param, value) {
  let url = new URL(window.location.href);
  let tmp = url.searchParams.getAll(param).filter(function(f) { return f !== value })
  url.searchParams.delete(param);
  tmp.forEach((element) => url.searchParams.append(param, element));
  setLocation(url);
}

function set_GET(param, value) {
  let url = new URL(window.location.href);
  url.searchParams.set(param, value);
  setLocation(url);
}

function clear_GET(param) {
  let url = new URL(window.location.href);
  url.searchParams.delete(param);
  setLocation(url);
}

function changePagePagination(page) {
    set_GET("page", $(page).attr("data-id-page-for-pagination"))
    window.location.reload()
}

/**
 * Функция обновления блока 2
 * @param {string} idBlockTarget
 * @param {string} urlBlock
 */
async function refreshBlock(idBlockTarget,urlBlock) {
    $(idBlockTarget).css("min-height", "100px");
    $(idBlockTarget).css("position", "relative");
    $(idBlockTarget).append('<div class="loading_bloor" id="loading_bloor"><span class="loader"></span></div>');
    // let loading_bloor = document.getElementById("loading_bloor");
    // if (loading_bloor) { loading_bloor.style.display="block"; }
    urlBlock += window.location.search; // Добавляем get параметры
    let data = await getDataBlock(urlBlock);
    if (data.response == true) {
        $(idBlockTarget).css("min-height", "");
        $(idBlockTarget).html(data.data);
    } else {
        console.log("Ошибка загрузки блока причина: "+data.description);
    }
}

/**
 * проверка корректности json
 *
 * @param {string} v_icon иконка
 * @param {string} v_title строка заголовка
 * @param {string} v_msg строка сообщения
 * @return {bool}
 */
function alerts(v_icon, v_title, v_msg) {
  Swal.fire({
    scrollbarPadding: false,
    icon: v_icon,
    title: v_title,
    text: v_msg
  })
}



